<template>
    <div class="scratchWroks container">
		<div class="worksInfo">
			<div class="worksInfo-top">
				<!-- <img :src="authorAvatar" alt=""> -->
				<img :src="themeData.logo" alt="">
				<!-- <span>{{ authorName }}</span> -->
			</div>
			<!-- <p class="worksname">{{ worksName }}</p> -->
		</div>
        <div class="works">
			<div v-if="scratchLoading" class="worksLoading">
				<img :src="themeData.logo" alt="">
				<div class="scratch-loading">
					<div class="filled" :style="`width: ${width}%`"></div>
				</div>
			</div>
			<div class="works-play" id="scratch-player"></div>
			<div class="panel-container f-cb" v-show="keyboard != 1">
				<div class="keyboardBox" v-if="keyboard == 2">
					<div class="sxzu-bar-one">
						<div class="key left arrow-left" id="mleftBtn"></div> 
						<div class="key down arrow-down" id="mdownBtn"></div> 
						<div class="key right arrow-right" id="mrightBtn"></div> 
						<div class="key up arrow-up" id="mupBtn"></div>
					</div> 
					<div class="space f-fr" id="mspaceBtn"></div>
					<div class="q" id="mqBtn">Q</div>
					<div class="w" id="mwBtn">W</div>
					<div class="e" id="meBtn">E</div>
				</div>
				<div class="keyboardBox" v-if="keyboard == 3">
					<div class="sxzu-bar">
						<div class="key left arrow-left" id="mleftBtn"></div> 
						<div class="key down arrow-down" id="mdownBtn"></div> 
						<div class="key right arrow-right" id="mrightBtn"></div> 
						<div class="key up arrow-up" id="mupBtn"></div>
					</div> 
					<div class="sxzu-bar-wasd">
						<div class="key keyW arrow-w" id="mwBtn">W</div> 
						<div class="key keyA arrow-a" id="maBtn">A</div> 
						<div class="key keyS arrow-s" id="msBtn">S</div> 
						<div class="key keyD arrow-d" id="mdBtn">D</div>
					</div> 
				</div>
				<div class="keyboardBox" v-if="keyboard == 4">
					<div class="num-keypad">
						<div class="key number" id="m7Btn">7</div>
						<div class="key number" id="m8Btn">8</div>
						<div class="key number" id="m9Btn">9</div>
						<div class="key number" id="m4Btn">4</div>
						<div class="key number" id="m5Btn">5</div>
						<div class="key number" id="m6Btn">6</div>
						<div class="key number" id="m1Btn">1</div>
						<div class="key number" id="m2Btn">2</div>
						<div class="key number" id="m3Btn">3</div>
					</div>
				</div>
				<div class="playGame" id="playGame">开始</div>
				<div class="stopGame" id="stopGame">结束</div>
			</div>
			<div class="heatWork">
				<div>
					<svg-icon icon-class="zan"/>{{likeNum}}
					<!-- <span class="like"></span>{{likeNum}} -->
				</div>
				<div><i class="el-icon-view"></i>{{visNum}}</div>
			</div>
			<div class="explain">
				<h5>作品简介：</h5>
				<p>{{ description }}</p>
			</div>
			<div class="explain">
				<h5>操作说明：</h5>
				<p>{{ direction }}</p>
			</div>
        </div>
        <div class="comment">
			<h5>评论：</h5>
			<ul class="commentList">
				<li
				  class="commentLi"
				  v-for="(item, index) in commentList"
				  :key="index"
				>
					<img class="commentAvatar" :src="item.reviewerAvatar" alt="">
					<div class="commentinfo">
						<span class="reviewerName">{{ item.reviewerName }}</span>
						<span class="createDate">{{ item.createDate }}</span>
						<span class="commentContent">{{ item.content }}</span>
						<ul v-if="item.discussions">
							<li
							  class="commentLi"
							  v-for="(dis, index) in item.discussions"
							  :key="index"
							>
								<img class="commentAvatar" :src="dis.replierAvatar" alt="">
								<div class="commentinfo">
									<span class="reviewerName">{{ dis.replierName }}</span>
									<span class="createDate">{{ dis.createDate }}</span>
									<p class="commentContent">{{ dis.content }}</p>
								</div>
							</li>
						</ul>
					</div>					
				  </li>
			</ul>
			<span v-if="!commentList.length" class="noComment">暂无评论</span>
        </div>
		<div class="footerJoinBox">
			<a class="footerJoin" :href="`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${themeData.wxAppId}&redirect_uri=https%3a%2f%2fwww.${institutionConfig.baseDomainName}%2fjiaxiao%2fjoinStudy%3fitid%3d${themeData.id}%26atid%3d${authorId}&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=wx18ec7edf87151a7e#wechat_redirect`"></a>
		</div>
		<!-- <div class="schoolInfo">
			<div class="schoolInfo-logo">
				<img :src="themeData.logo" alt="">
			</div>
			<div class="schoolInfo-info">
				<h4>{{ themeData.name }}</h4>
				<p class="address"><i class="el-icon-location"></i>{{ themeData.address }}</p>
				<p class="phone"><i class="el-icon-phone"></i>{{themeData.contactPhone }}</p>
			</div>
		</div> -->
		<!-- <button class="join_btn" @click="goJoin">我也想学</button> -->
    </div>
</template>
<script>
import wx from "weixin-js-sdk";
import wxApi from '@/request/api/wx';
import institutionApi from '@/request/api/institution';
import communityApi from "@/request/api/community";
export default {
	computed: {
		themeData() {
            return this.$store.state.themeData;
        }
	},
	data() {
		return {
			worksName: "", //当前作品名称
			worksId: "", //当前作品的id
			description: "", //作品简介
			direction: "", //操作说明
			commentList: [], //评论列表
			scratchLoading: true, //页面loading
			cover:"",//作品封面
			authorAvatar: "",
			authorId: "", //作者id
			authorName: "",
			width: 0,
			keyboard: 2,
			likeNum: "",
			visNum: "",
		}
	},
	created() {
		//存字段，通过字段加载窗口
		sessionStorage.setItem('mobile', true);
		this.getWorksInfo();
		this.width += 10;
	},
	mounted() {
		this.setLookNum();
		this.getScratchJS();
	},
	beforeRouteLeave (to, from, next) {
        document.getElementById('stopGame').click();
        next();
    },
	methods: {
		//获取当前作品的信息
		getWorksInfo() {
			let arr = location.href.split('?');
			this.worksId = arr[0].slice(location.href.lastIndexOf('/') + 1)
            communityApi.worksDetailsById(this.worksId, res => {
				if(res.succeed) {
					this.description = res.data.description? res.data.description: "";
					this.direction = res.data.direction? res.data.direction : "";
					this.cover = res.data.cover;
					this.worksName = res.data.name? res.data.name : this.name;
					this.authorAvatar = res.data.authorAvatar? res.data.authorAvatar : "";
					this.authorId = res.data.authorId? res.data.authorId : "";
					this.authorName = res.data.authorName? res.data.authorName : "";
					this.likeNum = res.data.likeNum;
					this.visNum = res.data.visNum;
					this.keyboard = res.data.keyboard? res.data.keyboard : 2;
					this.getComment(); //获取作品成功后再获取当前作品评论
					this.shareSignature();
				}
			})
		},
		//查看次数
        setLookNum() {
            let params = {
                institutionId: this.themeData.id, 
                type: 'workViewNumByPhone'
            };
            institutionApi.statisticsByInstitutionId(params, res => {
            });
        },
		//获取作品评论列表
        getComment() {
            communityApi.worksDiscussionList(this.worksId, res => {
                if(res.succeed) {
                    this.commentList = res.data? res.data: [];
                }
            })
		},
		//加载scratch
        getScratchJS() {
			this.width += 15;
            const oScript1 = document.createElement('script');
            oScript1.type = 'text/javascript';
			oScript1.src = 'https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/player/compatibility.js';
			this.width += 15;
			document.body.appendChild(oScript1);
			this.width += 25;
            const oScript2 = document.createElement('script');
            oScript2.type = 'text/javascript';
			oScript2.src = 'https://scratch-highcoding.oss-accelerate.aliyuncs.com/lib/community/lib.min.js';
			this.width += 10;
			oScript2.onload = () => {
				this.width = 88;
				setTimeout(() => {
                    this.width = 95;
				}, 1500)
                setInterval(() => {
					this.width = 100;
					this.scratchLoading = false;
				}, 3000)
            }
            document.body.appendChild(oScript2);
		},
		//微信分享
		shareSignature() {
			let url = location.href;
			let title = '';
			let desc = '';
			let imgUrl = '';
			let link = window.location.href;
			let params = {
				"url": url,
				"appId": this.themeData.wxAppId
			};
			wxApi.shareSignature(params, res => {
				if(res.succeed) {
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: res.data.appid, // 必填，公众号的唯一标识
						timestamp: res.data.timestamp, // 必填，生成签名的时间戳
						nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
						signature: res.data.signature, // 必填，签名
						jsApiList: [
							"onMenuShareAppMessage",  //旧的接口，即将废弃
							"onMenuShareTimeline" //旧的接口，即将废弃
						] // 必填，需要使用的JS接口列表
					})
					title =  `${this.authorName} 的编程作品《${this.worksName}》`;
					desc = `我家宝在${this.themeData.name}学习编程,做了很多有意思的编程作品,点进来玩玩吧`;
					imgUrl = `http:${this.cover==''?this.themeData.logo:this.cover}`;
					//微信公众号签名成功后的回调
					wx.ready(() => {
						//需在用户可能点击分享按钮前就先调用
						//分享给朋友、QQ
						wx.onMenuShareAppMessage({
							title: title, // 分享标题
							desc: desc, // 分享描述
							link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: imgUrl, // 分享图标type: '', // 分享类型,music、video或link，不填默认为link
                    		dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
							success: () => {
								institutionApi.statisticsByInstitutionId({ institutionId: this.themeData.id, type: 'workShareNum' }, res => {
									
								})
							}
						});
						//分享到朋友圈、QQ空间
						wx.onMenuShareTimeline({
							title: title, // 分享标题
							link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: imgUrl, // 分享图标
							success: () => {
								institutionApi.statisticsByInstitutionId({ institutionId: this.themeData.id, type: 'workShareNum' }, res => {
									
								})
							}
						});
					});
					wx.error(function(res) {
					// console.log(res.errMsg)// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
					});
				}
			})
		},
		//加入
		goJoin() {

		}
	}
}
</script>
<style scoped>
.scratchWroks {
	width: 100%;
	height: 100%;
	user-select: none;
	overflow: hidden;
}
.container {
	padding: 0;
}
.schoolInfo {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	padding: 15px 5px;
	background-color: var(--theme-color);
}
.schoolInfo-logo {
	width: 30%;
}
.schoolInfo-logo img {
	width: 100%;
}
.schoolInfo-info {
	width: 68%;
	padding-left: 10px;
}
.schoolInfo-info .address {
	color: #fff;
	font-size: 13px;
}
.schoolInfo-info .phone {
	color: #fff;
	font-size: 13px;
	margin-bottom: 0;
}
.schoolInfo-info h4 {
	color: #fff;
	font-size: 18px;
	font-weight: 600;
	margin: 0;
}
.worksInfo {
	display: flex;
	flex-flow: column nowrap;
	justify-content: center;
	align-items: center;
	background-color: #fff;
}
.worksInfo-top {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	/* margin-bottom: 10px; */
	padding: 5px;
	background-color: var(--theme-color);
}
.worksInfo-top img {
	max-height: 45px;
	/* border-radius: 50%; */
}
.worksInfo .worksname {
	font-size: 18px;
	font-weight: bold;
	margin: 0;
	padding: 10px;
}
.worksInfo-top span {
	display: block;
	color: #fff;
	font-size: 20px;
	padding: 15px;
	
}
.worksInfo .address {
	font-size: 18px;
	font-weight: bold;
}
.works {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.worksLoading {
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	background-color: var(--theme-color);
	z-index: 999;
}
.worksLoading img {
	max-width: 300px;
	max-height: 35%;
}
.scratch-loading{
	width: 80%;
	height: 50px;
	margin-top: 5rem;
	background-color: #e6e6e6;
	border: 5px solid #fff;
	border-radius: 25px;
	box-shadow: 0 12px 5px rgba(0, 0, 0, 0.2);
	box-sizing: border-box;
	overflow: hidden;
}
.scratch-loading .filled{
	height: 100%;
	width: 0%;
	border-radius: 25px;
	background-color: var(--theme-color);
}
.works-play {
	min-height: 280px;
    overflow: hidden;
}
.panel-container {
    position: relative;
    width: 100%;
    min-height: 200px;
    /* margin-bottom: 15px; */
    background-color: #323238;
}
.keyboardBox {
	width: 100%;
}
.sxzu-bar {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 160px;
    height: 150px;
}
.sxzu-bar-one .key,
.sxzu-bar-wasd .key,
.sxzu-bar .key {
    position: absolute;
    width: 60px;
    height: 60px;
}
.sxzu-bar-one,
.sxzu-bar-wasd {
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
	width: 160px;
	height: 150px;
}
.num-keypad {
	position: absolute;
	top: 50px;
	display: flex;
	flex-flow: row wrap;
	justify-content: center;
	width: 100%;
}
.num-keypad .number{
	width: 25%;
	height: 35px;
	margin: 5px;
	color: #B4BCBD;
	font-size: 18px;
	font-weight: 600;
	text-align: center;
	line-height: 35px;
	background: #585A60;
	border-radius: 5px;
}
.num-keypad .number:active {
	background: #73777B;
	color: #fff;
}
.arrow-left {
    background: url(../../assets/icon/left.png) no-repeat center/contain;
}
.arrow-right {
    background: url(../../assets/icon/right.png) no-repeat center/contain;
}
.arrow-up {
    background: url(../../assets/icon/up.png) no-repeat center/contain;
}
.arrow-down {
    background: url(../../assets/icon/down.png) no-repeat center/contain;
}
.keyA,
.left {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}
.left:active {
    background: url(../../assets/icon/left_active.png) no-repeat center/contain;
}
.keyD,
.right {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.right:active {
    background: url(../../assets/icon/right_active.png) no-repeat center/contain;
}
.keyW,
.up {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}
.up:active {
    background: url(../../assets/icon/up_active.png) no-repeat center/contain;
}
.keyS,
.down {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
.down:active {
    background: url(../../assets/icon/down_active.png) no-repeat center/contain;
}
.sxzu-bar-wasd .key,
.space, .q, .w, .e{
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 60px;
    height: 60px;
    align-items: center;
    background: #585A60;
    color: #B4BCBD;
    font-size: 33px;
    border-radius: 50%;
}
.sxzu-bar-wasd .key:active,
.q:active, .w:active, .e:active {
    background: #73777B;
    color: #fff;
}
.space {
    width: 90px;
    height: 90px;
    right: 10px;
    bottom: 25px;
    background: url(../../assets/icon/space.png) no-repeat center/contain;
}
.space.default {
	width: 110px;
	height: 110px;
	right: 20px;
	bottom: 50%;
	transform: translateY(50%);
}
.space:active {
    background: url(../../assets/icon/space_active.png) no-repeat center/contain;
}
.q {
    right: 105px;
    bottom: 20px;
}
.w {
    right: 90px;
    bottom: 90px;
}
.e {
    right: 28px;
    top: 18px;
}
.playGame,
.stopGame {
    position: absolute;
    left: 50%;
    top: 15px;
    transform: translateX(-50%);
    width: 45px;
    height: 25px;
    line-height: 25px;
    font-size: 15px;
    text-align: center;
    color: #fff;
    background: green;
    border-radius: 5px;
}
.stopGame {
    display: none;
    background: red;
}
.explain,
.comment {
	width: 100%;
	padding: 0px 20px;
}
.explain h5,
.comment h5 {
	font-size: 15px;
	font-weight: 600;
	padding: 0;
}
.explain p {
	font-size: 14px;
	padding: 0 10px;
}
.commentList {
	width: 100%;
	padding: 0 10px;
}
.noComment {
	font-size: 14px;
	padding: 0 10px;
}
.commentLi {
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	width: 100%;
	padding: 5px 0;
	border-bottom: 1px solid #eee;
}
.commentAvatar {
	width: 35px;
	min-height: 35px;
}
.reviewerName {
    color: #1eace5;
}
.createDate {
	display: inline-block;
	margin-left: 15px;
    font-size: 12px;
    color: #777;
}
.commentinfo {
	width: 100%;
	padding-left: 5px;
}
.commentContent {
	display: block;
	min-height: 30px;
	font-size: 15px;
	word-break: break-all;
	white-space: normal;
}
.footerJoinBox {
	width: 100%;
	margin-top: 22%;
}
.footerJoin {
	position: fixed;
	bottom: 0;
	width: 100%;
	height: 14%;
	background: url(../../assets/joinbg.png) no-repeat center/contain;;
}
/* .heatWorkShow {
	display: none;
	width: 100%;
} */
.heatWork {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	padding: 10px 30px 0;
}
.heatWork i {
	margin-right: 5px;
}
.heatWork div {
	margin-right: 10px;
}
.heatWork .like {
	padding: 7px;
	margin-right: 5px;
	background-image: url("../../assets/zan5.png");
	background-repeat: no-repeat;
	background-position: center center;
	background-size: contain;
	cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/scratchwork/scratchwork.vue